(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-script"] && !Shopify.designMode) return;
  try {
    (function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('cart_open') !== 'true') return;

    function stripCartOpenParam() {
      const p = new URLSearchParams(window.location.search);
      p.delete('cart_open');
      const qs = p.toString();
      window.history.replaceState({}, document.title, window.location.pathname + (qs ? '?' + qs : ''));
    }

    function tryOpenCartDrawer(attempt) {
      const maxAttempts = 50;
      const btn = document.querySelector('[data-drawer-open="[data-mini-cart]"]');
      if (btn) {
        btn.click();
        stripCartOpenParam();
        return;
      }
      if (attempt < maxAttempts) {
        setTimeout(function () {
          tryOpenCartDrawer(attempt + 1);
        }, 200);
      }
    }

    function start() {
      customElements.whenDefined('wyatt-drawer').then(function () {
        requestAnimationFrame(function () {
          tryOpenCartDrawer(0);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Shopify) return;
    const shopId = window.shopId;
    const merchantName = window.merchantName;
    const shopUrl = window.shopUrl;
    const accessToken = '1f4f13fe320f9b7d9b9a05f89e13ea87';
    const buyerCountry = window.Shopify.country;
    const buyerLocale = window.Shopify.locale;
    const buyerCurrency = window.Shopify.currency ? window.Shopify.currency.active : null;
    const encodedOrigin = encodeURIComponent(shopUrl);
    const iframeSrc = `${shopUrl}/services/login_with_shop/authorize?target_origin=${encodedOrigin}&flow=shop_pay_button`;
    window.shopPaymentConfig = {
      shopId: shopId,
      merchantName: merchantName,
      accessToken: accessToken,
      buyerCountry: buyerCountry,
      buyerLocale: buyerLocale,
      buyerCurrency: buyerCurrency,
      iframeSrc: iframeSrc,
      recommendedConfig: {
        name: 'shop_pay',
        wallet_params: {
          shopId: shopId,
          merchantName: merchantName,
          personalized: true,
        },
      },
      fallbackConfig: {
        name: 'buy_it_now',
        wallet_params: {},
      },
      shopPayWalletParams: {
        shopId: shopId,
        merchantName: merchantName,
        personalized: true,
      },
    };
  });
  } catch(e) { console.error(e); }
})();

})();
